export default {
  label: {
    series: 'Avaliações',
  },
};
